import { MealSize } from '../../src/ts/@types/generated/graphql/catalog-service/graphql';

export const DEFAULT_TENANT_ELIGIBILITY_CONFIG_LOGICAL_ID = 'DEFAULT';

/**
 * Regex patterns for input validation
 */

export const RegexPatterns = {
  EMAIL_REGEX:
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  CONTACT_NUMBER_REGEX: /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
  CONTACT_NUMBER_INTL_CODE_REGEX: /^[^1+]/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W])(?=.{6,})/,
  IS_BIGGER_THAN_SIX_CHARS: /^(?=.{6,})/,
  HAS_UPPERCASE_LETTER: /^(?=.*[A-Z])/,
  HAS_NUMBER: /^(?=.*[0-9])/,
  HAS_SPECIAL_CHAR: /^(?=.*[\W])/,
  ZIP_CODE: /^\d{5}([-]?\d{4})?$/,
};

export const RailsCookies = {
  REMEMBER_USER_TOKEN: 'remember_user_token',
  SESSION_ID: 'session_id',
  USER_ID: 'userId',
};

export const FUNNEL_PATH_NAMES = ['/get-started', '/menu', '/checkout'];

export const DESKTOP_MENU_NAV_BAR_HEIGHT = 66;
export const MOBILE_MENU_NAV_BAR_HEIGHT = 56;

export const GET_STARTED_MOBILE_IMAGE_HEIGHT = 410;

export const ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
export const CART_ID_COOKIE_KEY = 'cartId';
export const DISMISS_ACTIVE_SUBSCRIPTION_MODAL_COOKIE =
  'dismissActiveSubscriptionModal';

export const CART_ID_QUERY_PARAM_KEY = CART_ID_COOKIE_KEY;
export const REFERRAL_CODE_PARAM_KEY = 'r';
export const DISCOUNT_CODE_PARAM_KEY = 'discountCode';
export const ZIP_CODE_PARAM_KEY = 'zip';
export const USER_NAME_PARAM_KEY = 'name';
export const USER_EMAIL_PARAM_KEY = 'email';
export const SELECTED_DELIVERY_DATE_PARAM_KEY = 'selectedDeliveryDate';
export const TENANT_ELIGIBILITY_CONFIG_LOGICAL_ID_PARAM_KEY = 'catalogId';
export const TAG_ID = 'tagId';
export const PLAN_PARAM_KEY = 'plan';

export const GraphQLErrorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
};

export const GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again later.';

export const HONEYBADGER_TAGS = {
  segment: 'segment',
};

export const ENVIRONMENTS = {
  production: 'prod',
  staging: 'stg',
  development: 'dev',
};

/**
 * At this point we're not swithcing back to multi-size and we've defaulted to this.
 */
export const DEFAULT_MEAL_SIZE = MealSize.Standard;

export const STATE_ABBREVIATIONS = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

/**
 * Key stored in localStorage to query programs on programs confirmation page, and know if we
 * should trigger "Order Completed" analytics event on the programs confirmation page.
 * If present: trigger and delete key from localStorage
 * If not present: do nothing
 */
export const PROGRAM_CONFIRMATION_KEYS = {
  programId: 'programId',
  tenantId: 'tenantId',
};

export const IngredientToAvoidIds = {
  COCONUT: 44,
  COCONUT_AMINOS: 48,
  DAIRY: 53,
  EGGS: 1,
  FISH: 2,
  PEANUTS: 33,
  SESAME: 22,
  SESAME_OIL: 65,
  SHELLFISH: 5,
  SOY: 30,
  TREE_NUTS: 6,
  WHEAT: 61,
};
